module.exports = __webpack_public_path__ + "img/clock1-01.3ead1897.png";